<template>
  <div class="public">
    <a class="public__logo-container">
      <img src="@/assets/imgs/logo.svg" />
    </a>
    <div class="public__content">
      <slot></slot>
    </div>
  </div>
</template>

<style scoped>
.public__content {
  max-width: 1000px;
  margin: auto;
  margin-top: 50px;
  margin-bottom: 5%;
}
.public__logo-container {
  position: absolute;
  height: 40px;
  width: 40px;
  left: 20px;
  top: 20px;
  display: flex;
}
@media (min-width: 1700px) {
  .public__content {
    margin-top: 200px;
  }
}
</style>

<script>
import BgTypography from "@/directives/bg-typography";

export default {
  name: "PublicLayout",
  directives: {
    BgTypography,
  },
};
</script>
